module.exports = "<div id=\"totop\" style=\"display: block;\" (click)=\"actionTop(300)\">\n<span class=\"fas fa-chevron-up\"></span>\n</div>"